module.exports = __webpack_public_path__ + "static/media/united-state.6d23b562.svg";